<template>
  <b-modal id="modal-alterar-data-envio" dialog-class="modal-conta" size="lg" hide-footer :no-enforce-focus="true">
    <template slot="modal-header">
      <h5 class="modal-title">Alterar data de envio dos brindes selecionados</h5>
      <button type="button" class="close" aria-label="Close" @click="$bvModal.hide('modal-alterar-data-envio')">
        <span aria-hidden="true">&times;</span>
      </button>
    </template>

    <div class="row">
      <div class="col-12 col-md">
        <b-form-datepicker
          placeholder="Nenhuma data selecionada"
          label-no-date-selected="Nenhuma data selecionada"
          label-help="Use as setas do teclado para navegar entre as datas"
          v-model="dataEnvioRecompensa"
        ></b-form-datepicker>
      </div>
    </div>

    <div class="text-center">
      <div class="d-flex align-items-center justify-content-center mt-4 mb-4">
        <button class="btn btn-primary mr-3" type="button" @click="atualizarDataEnvio">Atualizar</button>
        <a href="javascript:void(0)" class="btn btn-secondary" @click="$bvModal.hide('modal-alterar-data-envio')">Cancelar</a>
      </div>
    </div>

  </b-modal>
</template>

<script>
import BrindesApi from '@/api/brindes-api'
import Swal from 'sweetalert2'
import ResponseUtils from '@/core/util/response-utils'

export default {
  name: 'ModalAlterarDataEnvio',
  props: {
    brindes: Array
  },
  data () {
    return {
      dataEnvioRecompensa: null
    }
  },

  mounted () {
    this.$root.$on('bv::modal::show', () => {
      this.dataEnvioRecompensa = null
    })
  },

  methods: {
    show: function () {
      this.$bvModal.show('modal-alterar-data-envio')
    },
    atualizarDataEnvio: function () {
      const loader = this.$loading.show()

      this.brindes.map(brinde => {
        brinde.dataEnvio = this.dataEnvioRecompensa
      })

      let brindesSelecionados = {
        'brindes': this.brindes
      }

      BrindesApi.atualizarDataEnvioLote(brindesSelecionados).then(data => {
        loader.hide()
        Swal.fire({
          icon: 'success',
          showCloseButton: true,
          text: 'Data de envio dos brindes selecionados atualizada com sucesso!'
        }).then(() => {
          this.$bvModal.hide('modal-alterar-data-envio')
          this.$emit('dataEnvioAlterada')
        })
      }).catch(error => ResponseUtils.handleError(error))
    }
  }
}
</script>
